import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-40 w-full bg-ink text-paper" data-id="element-1" data-mp="omwq1i5aglap">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2 sm:px-5 sm:py-2.5" data-id="element-2" data-mp="jssiawo7898k">
        <p className="text-[11px] font-medium leading-snug sm:text-[13px]" data-id="element-3" data-mp="euh7ojq2xupa">
          <span className="font-semibold text-rust-soft" data-id="element-4" data-mp="9wywsnsi55en">Promo:</span>{' '}
          <span className="sm:hidden" data-id="element-5" data-mp="5ukhueryepsn">6 volumes + 5 free bonuses — 60% off, only $19</span>
          <span className="hidden sm:inline" data-id="element-6" data-mp="uzfdudkrzb6">
            get the 6-volume bundle + 5 free bonuses for 60% off — only $19. Offer ends tonight.
          </span>
        </p>
        <div className="flex shrink-0 items-center gap-2" data-id="element-7" data-mp="3s3n2aergruku">
          <span className="hidden text-[11px] font-semibold uppercase tracking-[0.14em] text-paper/60 sm:inline" data-id="element-8" data-mp="1v87dpw0ret1k">
            Ends in
          </span>
          <span className="text-[11px] font-semibold tabular-nums text-paper sm:text-[13px]" data-id="element-9" data-mp="1q8cp5z4gifjo">
            {hours}:{minutes}:{seconds}
          </span>
        </div>
      </div>
    </div>;
}